import { Answer, Question } from "../model";

/**
 * @returns the answer for the given question from the list of answers provided, or null if none can be found
 */
export const getAnswer = (question: Question, answers: Answer[]): Answer | null => {
    return answers.find(({questionId}) => questionId === question.id) || null;
}